import { Case, Flex, Icon, IconName, Switch } from '@talos/kyoko';
import type { AppNotificationSeverity } from './types';

export const AppInboxSeverityIcon = ({ severity: notification = 'Low' }: { severity?: AppNotificationSeverity }) => {
  return (
    <Flex alignItems="center">
      <Switch value={notification}>
        <Case value="Low">
          <Icon icon={IconName.InformationCircle} />
        </Case>
        <Case value="Medium">
          <Icon color="colors.yellow.lighten" icon={IconName.ExclamationSolid} />
        </Case>
        <Case value="High">
          <Icon color="colors.red.lighten" icon={IconName.ExclamationSolid} />
        </Case>
      </Switch>
    </Flex>
  );
};
